import { createRouter } from "vue-router"
import { createWebHistory } from "vue-router";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'main_page',
            component: () => import('./views/Main'),
            meta: {
                title: 'Главная страница'
            }
        },
        {
            path: '/report/:id',
            name: 'report_view',
            component: () => import('./views/Report'),
            meta: {
                title: 'Отчёт №',
                param: 'id'
            }
        },
        {
            path: '/delete-report/:id',
            name: 'delete_report_view',
            component: () => import('./views/DeleteReport'),
            meta: {
                title: 'Отчёт на удаление №',
                param: 'id'
            }
        },
        {
            path: '/event',
            name: 'event_view',
            component: () => import('./views/Event'),
            meta: {
                title: 'Событие №',
                query: 'eventId'
            }
        },
        {
            path: '/settings/users',
            name: 'users',
            component: () => import('./views/settings/Users'),
            meta: {
                title: 'Пользователи'
            }
        },
        {
            path: '/settings/parameters',
            name: 'parameters',
            component: () => import('./views/settings/Parameters'),
            meta: {
                title: 'Параметры'
            }
        },
        {
            path: '/functions/borrowers',
            name: 'borrowers',
            component: () => import('./views/functions/Borrowers'),
            meta: {
                title: 'Заёмщики'
            }
        },
        {
            path: '/functions/borrower/:uuid',
            name: 'borrower_view',
            component: () => import('./views/functions/BorrowerView'),
            meta: {
                title: 'Заёмщик №',
                param: 'uuid'
            }
        },
        {
            path: '/functions/loans',
            name: 'loans',
            component: () => import('./views/functions/Loans'),
            meta: {
                title: 'Займы'
            }
        },
        {
            path: '/functions/loan-history',
            name: 'loan_history',
            component: () => import('./views/functions/LoanHistory'),
            meta: {
                title: 'История'
            }
        },
        {
            path: '/functions/events',
            name: 'events',
            component: () => import('./views/functions/Events'),
            meta: {
                title: 'События'
            }
        },
        {
            path: '/functions/loan/:id',
            name: 'loan_view',
            component: () => import('./views/functions/LoanView'),
            meta: {
                title: 'Займ №',
                param: 'id'
            }
        },
        {
            path: '/functions/close-loan',
            name: 'loan_close',
            component: () => import('./views/functions/CloseLoan'),
            meta: {
                title: 'Закрытие займа'
            }
        },
        {
            path: '/functions/close-limit',
            name: 'limit_close',
            component: () => import('./views/functions/CloseLimit'),
            meta: {
                title: 'Закрытие лимита'
            }
        },
        {
            path: '/functions/resend-loan',
            name: 'loan_resend',
            component: () => import('./views/Correction/ResendCH.vue'),
            meta: {
                title: 'Перевыгрузка КИ'
            }
        },
        {
            path: '/functions/resend-events',
            name: 'events_resend',
            component: () => import('./views/Correction/ResendEvents.vue'),
            meta: {
                title: 'Повторная отправка событий'
            }
        },
        {
            path: '/functions/crypt',
            name: 'crypt',
            component: () => import('./views/functions/Crypt'),
            meta: {
                title: 'Шифрование'
            }
        },
        {
            path: '/functions/report-responses',
            name: 'report-responses',
            component: () => import('./views/functions/ReportResponses'),
            meta: {
                title: 'Файлы ответа'
            }
        },
        {
            path: '/functions/downloads',
            name: 'downloads',
            component: () => import('./views/functions/Downloads'),
            meta: {
                title: 'Выгрузки'
            }
        },
        {
            path: '/functions/export-files',
            name: 'export-files',
            component: () => import('./views/functions/ExportFiles'),
            meta: {
                title: 'Выгрузка файлов'
            }
        },
        {
            path: '/functions/delete-data',
            name: 'delete-data',
            component: () => import('./views/functions/DeleteData.vue'),
            meta: {
                title: 'Удаление кредитной истории new'
            }
        },
        {
            path: '/functions/delete-ip',
            name: 'delete-ip',
            component: () => import('./views/InformationPart/DeleteInformationPart.vue'),
            meta: {
                title: 'Удаление информационной части(old)'
            }
        },
        {
            path: '/functions/delete-ip/:id',
            name: 'delete_information_part_view',
            component: () => import('./views/InformationPart/DeleteInformationPartView.vue'),
            meta: {
                title: 'Отчёт на удаление ИЧ №',
                param: 'id'
            }
        },
        {
            path: '/functions/resend-loan/:id',
            name: 'resend_loan_view',
            component: () => import('./views/Correction/ResendCHView.vue'),
            meta: {
                title: 'Отчёт на перевыгрузку КИ №',
                param: 'id'
            }
        },
        {
            path: '/functions/deleted-events',
            name: 'delete_events_view',
            component: () => import('./views/DeleteEvents/DeleteEventsView.vue'),
        },
        {
            path: '/functions/stop-load',
            name: 'stop-load',
            component: () => import('./views/functions/StopLoad'),
            meta: {
                title: 'Остановка передачи в БКИ'
            },
        },
        {
            path: '/functions/okb-report',
            name: 'okb-report',
            component: () => import('./views/functions/OkbReport'),
            meta: {
                title: 'Создание отчёта в ОКБ'
            }
        },
        {
            path: '/bureau/blocks-info',
            name: 'blocks-info',
            component: () => import('./views/Bureau/BlocksInfoView'),
            meta: {
                title: 'Просмотр данных по займу'
            }
        },
        {
            path: '/admin',
            name: 'admin',
            component: () => import('./views/admin/Admin'),
            meta: {
                title: 'Администрирование'
            }
        },
        {
            path: '/functions/audit',
            name: 'Audit',
            component: () => import('./views/functions/Audit.vue'),
            meta: {
                title: 'Формирование отчета аудита'
            }
        },
    ]
})

router.beforeEach((toRoute, fromRoute, next) => {
    let title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title + ' | БКИ Сервис' : 'БКИ Сервис'
    if (toRoute.meta && toRoute.meta.param && toRoute.meta.title) {
        title = toRoute.meta.title + toRoute.params[toRoute.meta.param] + ' | БКИ Сервис'
    }
    if (toRoute.meta && toRoute.meta.query && toRoute.meta.title) {
        title = toRoute.meta.title + toRoute.query[toRoute.meta.query] + ' | БКИ Сервис'
    }
    window.document.title = title

    next()
})

export default router